export const MEDIA_FILTER_TABS = [
  { key: 'best', variant: 'purple', text: 'BEST OF' },
  { key: 'blockAccess', variant: 'yellow', text: 'BLOCK ACCESS' },
  { key: 'product', variant: 'primary', text: 'PRODUCT' },
  { key: 'athletes', variant: 'rainbow', text: 'ATHLETES' },
]
